export default __webpack_public_path__ + "media/images/corp/bg-9528bc0971fe0194d1a57a05809fb202.jpg";